import { $http } from '../component-base/xhr';

const fansPicUrl = require('../../../assets/images/order-fans.png');
const diamondPicUrl = require('../../../assets/images/order-diamond.png');
const coinPicUrl = require('../../../assets/images/order-coin.png');

const OrderType = {
    Unknow: 0,
    XdouDeposit: 1,
    YdouDeposit: 2,
    ZdouDeposit: 3,
    Withdraw: 4,
    Merchant: 5,
    PhotoFans: 6,
    LiveFans: 7,
    NewForceFans: 8,
    PaidOrder: 9,
};

export const CONFIG = {
    deposit: {
        title: '快币',
        picUrl: coinPicUrl,
    },
    fans: {
        title: '快手粉条',
        picUrl: fansPicUrl,
    },
    withdraw: {
        title: '快手黄钻',
        picUrl: diamondPicUrl,
    },
};

export function getFansSpecification(order) {
    switch (order.orderType) {
        case OrderType.PhotoFans:
            return '普通粉条';
        case OrderType.LiveFans:
            return '直播粉条';
        case OrderType.NewForceFans:
            return '智能推广粉条';
    }
    return '';
}


export function getOrderCategory(orderType) {
    switch (orderType) {
        case OrderType.PhotoFans:
        case OrderType.LiveFans:
        case OrderType.NewForceFans:
            return 'fans';
        case OrderType.XdouDeposit:
        case OrderType.YdouDeposit:
        case OrderType.ZdouDeposit:
            return 'deposit';
        case OrderType.Withdraw:
            return 'withdraw';
        case OrderType.Merchant:
            return 'merchant';
    }
    return 'merchant';
}

export function getDealwithOrder(order, itemIndex = 0) {
    const list = [...order.itemList];
    const clickedItem = list.splice(itemIndex, 1) || [{}];
    const { oid, orderType, sellerNick, orderStatusView, orderCreateTime, orderFee } = order;
    const { name, picUrl, specification, totalFee, num } = clickedItem[0];
    return {
        oid,
        orderType,
        sellerNick,
        orderStatusView,
        orderCreateTime,
        name,
        picUrl,
        specification,
        orderFee,
        totalFee,
        num,
    };
}

export async function fetchOrderList(params, api) {
    const res = await $http.post(api || '/rest/csc/center/order/all/list', {
        ...params,
        entranceId: 1,
    });
    return res.data;
}

export async function fetchOrderDetail(params) {
    const res = await $http.post('/rest/csc/center/order/get', {
        ...params,
        entranceId: 1,
    });
    return res.data;
}
